/** "Up next": the play queue, as a panel over the main area. */

import { player, usePlayer } from "../core/player";
import { Artwork } from "./Artwork";
import { Icon } from "./Icons";
import { MoreButton } from "./PopupMenu";
import { clockTime } from "./Waveform";

export function QueueList({ compact = false }: { compact?: boolean }) {
  const p = usePlayer();
  if (!p.queue.length) return <div className="nv-empty">The queue is empty. Play a song, or add some with “Add to queue”.</div>;
  return (
    <ol className={`nv-queue ${compact ? "compact" : ""}`}>
      {p.queue.map((item, i) => {
        const t = item.track;
        const past = i < p.index;
        return (
          <li key={item.key} className={`${i === p.index ? "on" : ""} ${past ? "past" : ""}`} onDoubleClick={() => void player.jump(i)}>
            <Artwork trackId={t.id} seed={t.album || t.artist || t.title} size={compact ? 34 : 30} />
            <div className="nv-queue-text">
              <b title={t.title}>{t.title}</b>
              <span title={t.artist}>{t.artist}</span>
            </div>
            <span className="nv-queue-meta">
              {t.bpm != null ? Math.round(t.bpm) : "—"}
              {t.musicalKey && t.musicalKey !== "ambiguous" ? ` · ${t.musicalKey}` : ""}
            </span>
            {!compact && <span className="nv-queue-time">{clockTime(t.duration)}</span>}
            <MoreButton
              label={`Options for ${t.title}`}
              items={[
                { id: "play", label: "Play now", icon: "play", run: () => player.jump(i) },
                { id: "remove", label: "Remove from queue", icon: "close", disabled: i === p.index, run: () => player.removeAt(i) },
              ]}
            />
          </li>
        );
      })}
    </ol>
  );
}

export function QueuePanel({ onClose }: { onClose: () => void }) {
  const p = usePlayer();
  return (
    <aside className="nv-queue-panel" aria-label="Up next">
      <header>
        <b>Up next</b>
        <span className="nv-dim">{p.queue.length} songs</span>
        <span className="nv-spacer" />
        <button className="nv-iconbtn" title="Close" onClick={onClose}>
          <Icon name="close" />
        </button>
      </header>
      <QueueList />
    </aside>
  );
}
